import { createRouter, createWebHistory } from "vue-router";
import authService from "../services/auth";

import MainPage from "@/pages/MainPage";
import LeadList from "@/pages/Lead";
import Profile from "@/pages/Profile.vue";
import CreateLead from "@/pages/CreateLead.vue";

const routes = [
    {
        path: "/",
        name: "MainPage",
        component: MainPage,
    },
    {
        path: "/login",
        name: "Login",
        component: MainPage,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/my-leads",
        name: "LeadList",
        component: LeadList,
        meta: { title: "Лиды" },
    },
    {
        path: "/create-lead",
        name: "CreateLead",
        component: CreateLead,
        meta: { title: "Лид" },
    },


];

const router = new createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach(async (to) => {
    document.title = to.meta.title || "TahoCRM";
    localStorage.removeItem('leads'); 
    localStorage.removeItem('bids'); 
    localStorage.removeItem('orders'); 
    localStorage.removeItem('invoices'); 
    localStorage.removeItem('prices_bid'); 
    localStorage.removeItem('invoiceOrders'); 
    localStorage.removeItem('leads'); 
    localStorage.removeItem('invoiceMoneys'); 
    localStorage.removeItem('prices_order'); 
    localStorage.removeItem('touches');     
    if (
        // make sure the user is authenticated
        !authService.isLogged() &&
        // Avoid an infinite redirect
        to.name !== "Login" &&
        to.name !== "MainPage"
    ) {
        // redirect the user to the login page
        // this.$router.push('/')
        return { name: "Login" };
    }
    window.scrollTo(0, 0);
});

export default router;
